/*

 */
import {UIPHideable} from "@/engine/UIcomponents/UIPHideable.js";
import {UICMapList} from "@/engine/UIcomponents/UICMapList.js";
import {VectorLayer} from "@/engine/layers/vectorLayer.js";
import {geometryUtils} from "@/engine/helpers/geometryUtils.js";

export var UIWorkspacePane = L.Control.extend({

    includes: UIPHideable,

    initialize: function(options) {
        this.options = options?options:{};
        if (this.options.position === undefined) {
            this.options.position = "topleft";
        }
        this.map = null
        this.mapContext = this.options.mapContext
        this.workspaces = []
        this.layerUICs = {}
        this.mapList = new UICMapList(
            {
                view: "workspacePaneList",
                controlsView: "workspacePaneMapControls",
                id: "wsPane-ws",
                list: this.workspaces,
                listBuilder: this.workspacesList.bind(this),
                itemOptionsBuilder: function (ws) {
                    return {
                        download: ws.publicDownload || ws.mine || ws.shared,
                        deletable: ws.mine || ws.shared,
                        have_controls: ws.publicDownload || ws.mine || ws.shared || ws.writable,
                        preview: ws.getPreview(),
                        layerList: this.layersUIC(ws)
                    }
                }.bind(this),
                eventObject: this.mapContext,
                eventNamePrefix: "ws"
            }
        )
        this.mapContext.once("mh:initFinished", function () {
            this.mapList.open(this._div)
            this.mapList.list.length > 0 ? this.show() : this.hide()
            //this.update()
        }, this)
    },

    layersUIC: function (ws) {
        const layers = ws.getNotDrawingLayers()
        if (! this.layerUICs[ws.id]) {
            this.layerUICs[ws.id] = new UICMapList(
                {
                    view: "workspacePaneLayersList",
                    controlsView: "workspacePaneLayerControls",
                    id: "wsPane-ls",
                    list: layers,
                    listBuilder: ws.getNotDrawingLayers.bind(ws),
                    itemOptionsBuilder: function (l) {
                        return {
                            deletable: (ws.isMine() || ws.isWritable()) && layers.length > 1,
                            download: ws.publicDownload || ws.isMine() || ws.shared,
                            vectorLayer: l instanceof VectorLayer
                        }
                    },
                    eventObject: this.mapContext,
                    eventNamePrefix: "layer"
                }
            )
        } else {
            this.layerUICs[ws.id].close()
        }
        return this.layerUICs[ws.id]
    },

    /**
     * return the list of workspaces of the current map view area
     * @returns {*[]}
     */
    workspacesList: function () {
        return geometryUtils.layersCoveredWithBound(this.map.getBounds(), this.mapContext.getWorkspacesVisibleRealWritable())
    },

    update: function(ev) {
        if (this.mapList.updateList()) {
            this.mapList.list.length > 0 ? this.show() : this.hide()
        }
    },

    onAdd: function(map) {
        this._div = L.DomUtil.create('div', 'pane workspacePane');
        // stop mouse event to propagate to the map
        let stop = L.DomEvent.stopPropagation
        L.DomEvent
            .on(this._div, 'contextmenu', stop)
            .on(this._div, 'click', stop)
            .on(this._div, 'mousedown', stop)
            .on(this._div, 'touchstart', stop)
            .on(this._div, 'dblclick', stop)
            .on(this._div, 'wheel', stop)

        this.map = map
        this.map.on("moveend", this.update, this)

        this.mapContext.on("mh:wsCreated", this.update, this)
        this.mapContext.on("mh:wsDelete", this.update, this)

        this.hide();
        return this._div;
    },

});
